// M31 — Sentry init runs BEFORE React boots so the SDK can capture
// errors thrown during initial render. Has to come before the first
// import that triggers component code; Vite's import order is
// deterministic per the module graph so this is reliable.
import { initSentry } from './lib/sentry';
initSentry();

// M33 — Plausible analytics. Self-hosted on the maintainer's VPS at
// telemetry.isnull.io. No-ops on dev / preview / test builds; on prod
// it injects the Plausible script tag once and that's it. Fires
// before React mounts so the first pageview is captured even on
// quick-bounce visits.
import { initAnalytics } from './lib/analytics';
initAnalytics();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Roboto font (required by MUI)
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
